module.exports = __webpack_public_path__ + "static/media/1.f317d322.jpg";